<template>
    <div id="apricationQQ">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" @click="handleSearch()"
                               style="background-color:#409EFF;color: white;">
                        查询<i class="el-icon-search"></i>
                    </el-button>
                </div>
                <div style="float: right">
                    <el-date-picker
                            @change="datechang"
                            v-model="dateValues"
                            class="queryPzDate"
                            type="monthrange"
                            value-format="yyyy-MM"
                            align="right"
                            size="mini"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </div>



            </div>
        </div>

        <div class="leftdiv">
            <div class="leftDivTop">
                [科目]：<span id="titleKmName">{{titleKmName}}</span>

                <div style="float: right;margin-right: 5px;">
                    <el-button size="mini" @click="downloadedFile()"
                               style="background-color:#ffa526;color: white;">
                        下载<i class="el-icon-download"></i>
                    </el-button>
                </div>
            </div>
            <el-table
                    :data="tableData"
                    border
                    height="400"
                    size="mini"
                    style="width: 100%">
                <el-table-column
                        prop="pzDate"
                        label="日期"
                        width="180">
                </el-table-column>
                <el-table-column label="凭证字号" width="180">>
                    <template slot-scope="scope">
                        <a style="color: #409EFF;cursor: pointer" @click="handleView(scope.row)">{{scope.row.pzhStr}}</a>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="zyJl"
                        label="摘要">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pzhStr != null && scope.row.pzhStr != ''" style="color: #96a6ac;">{{scope.row.zyJl}}</span>
                        <span v-else style="color: rgba(0,0,0,0.8);">{{scope.row.zyJl}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="jfje"
                        label="借方(元)">
                </el-table-column>
                <el-table-column
                        prop="dfje"
                        label="贷方(元)">
                </el-table-column>
                <el-table-column
                        prop="yueFx"
                        label="方向">
                </el-table-column>
                <el-table-column
                        prop="yuE"
                        label="余额(元)">
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin-top: 35px;margin-right: 5px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    :page-sizes="[10, 50, 100, 500]"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
            ></el-pagination>
        </div>
        <div class="rightdiv">
            <div class="leftDivTop">
                <span style="font-weight: bold">⇆ </span>快速切换
            </div>
            <el-input
                    style="width: 100%;background-color: #f5fafe;height: 47px;"
                    placeholder="输入关键词进行筛选"
                    v-model="filterText">
            </el-input>
            <el-tree
                    style="height: 420px;overflow: auto;overflow-x: auto"
                    :indent="0"
                    class="filter-tree tree-line"
                    :data="kmList"
                    :props="defaultProps"
                    default-expand-all
                    :filter-node-method="filterNode"
                    @node-click="handleNodeClick"
                    ref="tree">
            </el-tree>
        </div>

        <pview v-if="pViewVisible" ref="pView"></pview>
    </div>
</template>
<script>
    import Pview from '../pingZheng/edit'

    export default {
        name: 'mxList',
        components: {
            Pview
        },
        data() {
            return {
                pViewVisible: false,
                filterText: '',
                kmList: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                currentPage: 1, //初始页
                pageSize: 10, //每页的数据
                total: 0,
                offset: 0,
                tableData: [],
                dicCode: '',
                titleKmName: '',
                startTimeStr: null,
                endTimeStr: null,
                pickerOptions: {
                    shortcuts: [{
                        text: '本月',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: '上月',
                        onClick(picker) {
                            let date = new Date();
                            // 2.获取今日的年月
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            const end = new Date(year,month-1,1);
                            const start = new Date(year,month-1,1);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                dateValues: []
            }
        },
        methods: {
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            handleNodeClick(data) {
                this.dicCode = data.dicCode;
                this.titleKmName = data.dicCode + ' ' + data.dicName;
                this.handleCurrentChange(this.currentPage);
            },
            datechang() {
                if (this.dateValues != null && this.dateValues.length > 0) {
                    this.startTimeStr = this.dateValues[0];
                    this.endTimeStr = this.dateValues[1];
                }else{
                    this.startTimeStr = null;
                    this.endTimeStr = null;
                }
            },
            searchTreeList() {
                //查询已经使用的科目列表
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/mingXiZhang/searchTreeList'),
                    method: 'post'
                }).then(res => {
                    if (res.data.code == 0) {
                        this.kmList = res.data.data;
                        if (this.kmList.length > 0) {
                            if(!this.dicCode){
                                this.dicCode = this.kmList[0].dicCode;
                                this.titleKmName = this.kmList[0].dicCode + ' ' + this.kmList[0].dicName;
                                this.handleCurrentChange(1);
                            }
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })
            },
            handleCurrentChange(cPage) {
                this.tableData = [];
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/mingXiZhang/list?td=' + new Date()),
                    method: 'get',
                    params: {
                        'offset': this.offset,
                        'limit': this.pageSize,
                        'dicCode': this.dicCode,
                        'startTimeStr': this.startTimeStr,
                        'endTimeStr': this.endTimeStr
                    }
                }).then(r => {
                    if (r.data.code == 0) {
                        this.tableData = r.data.data.pageUtils.rows;
                        this.total = r.data.data.pageUtils.total;
                        this.dateValues = r.data.data.dateValues;
                    } else {
                        this.$message({
                            type: 'error',
                            message: r.data.msg
                        })
                    }
                }).finally(r => {
                })
            },
            handleView(row){
                let id = row.id;
                this.pViewVisible = true;
                this.$nextTick(() => {
                    this.$refs.pView.int(id,1);
                })
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            handleSearch() {
                this.handleCurrentChange(1);
            },
            routeV(){
                let kmdm = this.$route.query.kmdm;
                if(kmdm){
                    let kmmc = this.$route.query.kmmc;
                    this.titleKmName = kmdm + ' ' + kmmc;
                    this.dicCode = kmdm;
                    this.dateValues = this.$route.query.dateValues;
                    this.datechang();
                    this.handleCurrentChange(1);
                }
            },
            downloadedFile(){
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/mingXiZhang/list?td=' + new Date()),
                    method: 'get',
                    responseType:'blob',   //返回类型
                    params: {
                        'offset': 0,
                        'limit': 10000,
                        'dicCode': this.dicCode,
                        'startTimeStr': this.startTimeStr,
                        'endTimeStr': this.endTimeStr,
                        'blob': "true"
                    }
                }).then(data => {

                    //通过返回的二进制流创建 Blob对象
                    let blob = new Blob([data.data],
                        {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                    );
                    let url = window.URL.createObjectURL(blob);
                    //方式一：该url就是由返回的二进制流创建的文件下载地址，可以直接使用 window.location.href = url;下载
                    //不过下载后需要手动修改文件名和后缀名

                    //方式二：触发浏览器的内置下载功能
                    let a = document.createElement('a')//创建一个a标签元素
                    a.style.display = 'none'//设置为不显示
                    a.href = url    //设置a标签的href属性
                    a.setAttribute('download', '明细账.xlsx')//设置下载的文件名
                    document.body.appendChild(a)//将a标签元素加入到页面中
                    a.click()//触发点击
                    document.body.removeChild(a) // 下载完成移除元素
                    window.URL.revokeObjectURL(url) // 释放掉blob对象

                }).finally(r => {
                })
            }
        },
        watch: {
            //监听路由跳转
            $route() {
                this.routeV();
            },
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },
        created: function () {
            //监听路由跳转
            this.routeV();
            this.searchTreeList();
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }

    .leftdiv >>> .el-timeline-item__timestamp.is-bottom {
        margin-top: 2px !important;
    }

    .el-collapse-item div {
        padding-left: 20px;
        padding-bottom: 15px;
    }

    .rightdiv >>> .el-collapse-item__arrow.el-icon-arrow-right {
        display: none;
    }

    .leftdiv {
        float: left;
        width: 74.66%;
        border: 1px solid #ddd;
        height: 530px;
        padding: 10px 0px;
    }

    .rightdiv {
        float: right;
        width: 24.9%;
        border: 1px solid #ddd;
        height: 530px;
        padding: 10px 10px;
    }

    .leftDivTop {
        text-align: left;
        margin: 0px 10px 10px 10px;
        font-size: 15px;
        color: #333;
    }

    #apricationQQ >>> .el-table--border td, .el-table--border th {
        border-right: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table--border th {
        border-right: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table {
        border: 1px solid #ddd !important;
        border-right: 0px;
    }

    .queryPzDate {
        margin-right: 5px;
    }
</style>
<style lang="scss">
    .tree-line {
        .el-tree-node {
            position: relative;
            padding-left: 16px; // 缩进量
        }

        .el-tree-node__children {
            padding-left: 16px; // 缩进量
        }

        // 竖线
        .el-tree-node::before {
            content: "";
            height: 100%;
            width: 1px;
            position: absolute;
            left: -3px;
            top: -26px;
            border-width: 1px;
            border-left: 1px dashed #52627C;
        }

        // 当前层最后一个节点的竖线高度固定
        .el-tree-node:last-child::before {
            height: 38px; // 可以自己调节到合适数值
        }

        // 横线
        .el-tree-node::after {
            content: "";
            width: 24px;
            height: 20px;
            position: absolute;
            left: -3px;
            top: 12px;
            border-width: 1px;
            border-top: 1px dashed #52627C;
        }

        // 去掉最顶层的虚线，放最下面样式才不会被上面的覆盖了
        & > .el-tree-node::after {
            border-top: none;
        }

        & > .el-tree-node::before {
            border-left: none;
        }

        // 展开关闭的icon
        .el-tree-node__expand-icon {
            font-size: 16px;
            // 叶子节点（无子节点）
            &.is-leaf {
                color: transparent;
                // display: none; // 也可以去掉
            }
        }

    }

</style>